import { OPERATION_IDS, ROUTE_IDS } from '../routes/ids.js';
import { MARKET_PRICE_ROUTE_IDS } from '../routes/market-price-route-ids.js';
import { MARKET_PRICES_GET, MARKET_PRICES_LIST, } from '../../operations/market-data.operations.js';
import { MARKET_PRICE_CREATE_COMMAND_ID, MARKET_PRICE_CORRECT_COMMAND_ID, } from '../descriptors/market-price-form-descriptors.js';
export const INSTRUMENTS_RESOURCE_ID = 'instruments';
export const INSTRUMENTS_LIST_QUERY_ID = 'query.data.instruments.list';
export const INSTRUMENTS_READ_QUERY_ID = 'query.data.instruments.get';
export const INSTRUMENTS_CREATE_COMMAND_ID = 'cmd.data.instruments.create';
export const INSTRUMENTS_UPDATE_COMMAND_ID = 'cmd.data.instruments.update';
export const INSTRUMENTS_RESOURCE = Object.freeze({
    id: INSTRUMENTS_RESOURCE_ID,
    authority: 'ORGANIZATION',
    scopeKind: 'ORGANIZATION',
    listRouteId: ROUTE_IDS.DATA_INSTRUMENTS,
    createRouteId: ROUTE_IDS.DATA_INSTRUMENT_CREATE,
    detailRouteId: ROUTE_IDS.DATA_INSTRUMENT_DETAIL,
    editRouteId: ROUTE_IDS.DATA_INSTRUMENT_EDIT,
    listOperationId: OPERATION_IDS.INSTRUMENT_LIST,
    readOperationId: OPERATION_IDS.INSTRUMENT_GET,
    createOperationId: OPERATION_IDS.INSTRUMENT_CREATE,
    updateOperationId: OPERATION_IDS.INSTRUMENT_UPDATE,
    tableDescriptorId: 'table.data.instruments',
    formDescriptorId: 'form.data.instrument',
    ownershipPolicy: 'ACTIVE_ORGANIZATION',
    rowActivation: 'DETAIL',
    kind: 'standard-list-form',
    listQueryId: INSTRUMENTS_LIST_QUERY_ID,
    readQueryId: INSTRUMENTS_READ_QUERY_ID,
    createCommandId: INSTRUMENTS_CREATE_COMMAND_ID,
    updateCommandId: INSTRUMENTS_UPDATE_COMMAND_ID,
});
export const MARKET_PRICES_RESOURCE_ID = 'market-prices';
export const MARKET_PRICES_LIST_QUERY_ID = 'query.data.marketPrices.list';
export const MARKET_PRICES_READ_QUERY_ID = 'query.data.marketPrices.get';
export const MARKET_PRICES_TABLE_ID = 'table.data.marketPrices';
export const MARKET_PRICES_RESOURCE = Object.freeze({
    id: MARKET_PRICES_RESOURCE_ID,
    authority: 'ORGANIZATION',
    scopeKind: 'ORGANIZATION',
    listRouteId: ROUTE_IDS.DATA_MARKET_PRICES,
    createRouteId: MARKET_PRICE_ROUTE_IDS.CREATE,
    detailRouteId: ROUTE_IDS.DATA_MARKET_PRICE_DETAIL,
    editRouteId: MARKET_PRICE_ROUTE_IDS.EDIT,
    listOperationId: MARKET_PRICES_LIST,
    readOperationId: MARKET_PRICES_GET,
    createOperationId: OPERATION_IDS.MARKET_DATA_CREATE,
    updateOperationId: OPERATION_IDS.MARKET_DATA_UPDATE,
    tableDescriptorId: MARKET_PRICES_TABLE_ID,
    formDescriptorId: 'form.data.marketPrice',
    ownershipPolicy: 'ACTIVE_ORGANIZATION',
    rowActivation: 'DETAIL',
    kind: 'standard-list-form',
    listQueryId: MARKET_PRICES_LIST_QUERY_ID,
    readQueryId: MARKET_PRICES_READ_QUERY_ID,
    createCommandId: MARKET_PRICE_CREATE_COMMAND_ID,
    updateCommandId: MARKET_PRICE_CORRECT_COMMAND_ID,
});
export const REFERENCE_DATA_RESOURCE_REGISTRY = Object.freeze({
    [INSTRUMENTS_RESOURCE.id]: INSTRUMENTS_RESOURCE,
    [MARKET_PRICES_RESOURCE.id]: MARKET_PRICES_RESOURCE,
});
export const PLATFORM_INSTRUMENTS_RESOURCE = Object.freeze({
    ...INSTRUMENTS_RESOURCE,
    authority: 'PLATFORM',
    ownershipPolicy: 'PLATFORM',
});
const { createRouteId: _createRouteId, editRouteId: _editRouteId, createOperationId: _createOperationId, updateOperationId: _updateOperationId, createCommandId: _createCommandId, updateCommandId: _updateCommandId, formDescriptorId: _formDescriptorId, ...platformMarketPricesReadOnly } = MARKET_PRICES_RESOURCE;
/** Platform market-data browsing stays read-only; single-org write authority is Organization-owned. */
export const PLATFORM_MARKET_PRICES_RESOURCE = Object.freeze({
    ...platformMarketPricesReadOnly,
    authority: 'PLATFORM',
    ownershipPolicy: 'PLATFORM',
    kind: 'standard-list-detail',
});
export const PLATFORM_DATA_RESOURCE_REGISTRY = Object.freeze({
    instruments: PLATFORM_INSTRUMENTS_RESOURCE,
    [MARKET_PRICES_RESOURCE.id]: PLATFORM_MARKET_PRICES_RESOURCE,
});
